module.exports = __webpack_public_path__ + "static/cubicles1-4c3d7c4a12a6e9f5d5be00047503283d.jpg";